export function getRoleHomePath(role) {
  switch (role) {
    case 'ADMIN':
    case 'TUTOR':
    case 'PARENT':
    case 'STUDENT':
      return '/dashboard';
    default:
      return '/dashboard';
  }
}

export function getRoleLabel(role) {
  switch (role) {
    case 'ADMIN':
      return 'Admin';
    case 'TUTOR':
      return 'Tutor';
    case 'PARENT':
      return 'Parent';
    case 'STUDENT':
      return 'Student';
    default:
      return 'Account';
  }
}

export function getTopNavLinks(role) {
  switch (role) {
    case 'ADMIN':
      return [
        { label: 'Dashboard', to: '/dashboard' },
        { label: 'Users', to: '/admin/users' },
        { label: 'Create', to: '/admin/users/create' },
        { label: 'Cohort', to: '/cohort' },
        { label: 'Approvals', to: '/admin/question-approvals' },
        { label: 'Audit', to: '/admin/audit' },
        { label: 'Mastery', to: '/analytics/mastery' },
        { label: 'Account', to: '/account' },
      ];
    case 'TUTOR':
      return [
        { label: 'Dashboard', to: '/dashboard' },
        { label: 'Practice', to: '/practice' },
        { label: 'My students', to: '/tutor/students' },
        { label: 'Create', to: '/admin/users/create' },
        { label: 'Cohort', to: '/cohort' },
        { label: 'Account', to: '/account' },
      ];
    case 'PARENT':
      return [
        { label: 'Dashboard', to: '/dashboard' },
        { label: 'My children', to: '/parent/students' },
        { label: 'Account', to: '/account' },
      ];
    case 'STUDENT':
      return [
        { label: 'Dashboard', to: '/dashboard' },
        { label: 'Practice', to: '/practice' },
        { label: 'Account', to: '/account' },
      ];
    default:
      return [];
  }
}

export function isRoleAllowed(userRole, allowedRoles) {
  return Boolean(
    userRole
      && Array.isArray(allowedRoles)
      && allowedRoles.includes(userRole),
  );
}
